import React from 'react';
import { useIntl } from 'react-intl';
import LoginForm from '../auth/LoginForm';

const SpeakerLogin = () => {
  const intl = useIntl();
  return (
    <LoginForm
      title={intl.formatMessage({ id: 'speaker.login.title', defaultMessage: 'Speaker Login' })}
      subtitle={intl.formatMessage({ id: 'speaker.login.subtitle', defaultMessage: 'Enter your credentials to access the speaker portal' })}
      redirectTo="/profile"
    />
  );
};

export default SpeakerLogin;
